/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import {Tabs, Modal, Input, Button, Icon} from "antd";
import {formatTime} from '../../../../utils'
import Apply from '../../components/apply'
import '../../style/public.css'
import PageTableComponent from "../../components/pageTable/PageTable";

import CmForm from "../../../../components/CmForm/CmForm";
import $ from "jquery";
const { confirm } = Modal;
const { TabPane } = Tabs;
const { TextArea } = Input;
export default class Application extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            tabList:[],
            page:1,
            size:10,
            count:0,
            data:[],
            currentName:'',
            selectedRows:[],
            reason:'',
            refuseVisible:false,
            selectedRowKeys:[],
            history:require("history").createHashHistory(),
        }
    }

    componentWillMount() {

    }
    componentDidMount() {
        this.tableList();
    }
    render() {
        return (
            <div style={{background: '#ffffff',
                padding: '24px 32px 16px 32px',
                margin: "15px 0 15px 15px",
                position: 'relative',
                borderRadius:5}}>
                {/*渲染选择框以及下载 功能*/}
                {this.renderTableList()}

                {/*渲染按钮*/}
                {this.renderBtn()}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }
    renderTableList() {
        return (
            <Tabs  activeKey={this.state.currentName} onChange={(value)=>{
                 this.setState({currentName:value,page:1},()=>{
                     if(value === '待我审核'){
                         this.getWaitList()
                     }else{
                         this.getList()
                     }
                 })
            }}>
                {this.state.tabList && this.state.tabList.length && this.state.tabList.map((item, index) => {
                    return (<TabPane tab={item} key={item}></TabPane>)
                })}
            </Tabs>
        )
    }
    renderBtn(){
        return(
            <div>

                <Modal
                    maskClosable={false}
                    keyboard={true}
                    title="不通过原因"
                    visible={this.state.refuseVisible}
                    onOk={()=>{
                        this.adopt('未通过')
                    }}
                    zIndex={99999999}
                    width={710}
                    centered
                    onCancel={()=>{
                        this.setState({refuseVisible:false})
                    }}
                >
                    <CmForm onSubmit={()=>{
                        this.adopt('未通过')
                    }}>
                        <TextArea rows={4} placeholder={'请输入不通过原因'}  value={this.state.reason} onChange={(e)=>{
                            this.setState({reason:e.target.value})
                        }}/>
                    </CmForm>
                </Modal>
            </div>
        )
    }

    renderData() {

        let columns=[
            {
                title: '申请人',
                dataIndex: 'userName',
            },
            {
                title: '所在单位',
                dataIndex: 'deptName',
            },
            {
                title: '提交申请时间',
                dataIndex: 'createTime',
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            }];
            if(this.state.currentName==='我已审核'){
                columns.push({
                    title: '审核时间',
                    dataIndex: 'updateTime',
                    render: (text, record) => {
                        return (<div>{formatTime(text)}</div>)
                    }
                })
            }
            columns.push({
                title: '申请资源数',
                dataIndex: 'applyNum',
                align:'center'
            });
        columns.push(
            {
                title: '状态',
                dataIndex: 'status',
                render: (text, record) => {
                    let color;
                    if(text === '不通过'){
                        color = 'red'
                    }
                    return (<div style={{color:color}}>{text}</div>)
                }
            },
        );
        columns.push({
            title: '操作',
            render: (text, record) => {
                let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
                return (<div style={{ color:newSecondSelectColor}}><span style={{cursor: "pointer"}} onClick={() => {
                    this.state.selectedRows =[];
                    this.state.selectedRows.push(record);
                    this.setState({},()=>{
                    });
                    this.showModalApply(record)
                }}>查看</span>
                    {this.state.currentName === '我的申请'&&record.status==='审核通过' ?<span style={{marginLeft:10,cursor:'pointer'}} onClick={() => this.download(record)}
                    >下载</span>:null}
                </div>)
            }
        });

        return (
            <div >
                    <PageTableComponent columns={columns}

                                        rowKey="id"
                                        positionHeight={12}
                                        className={"tabList"}
                                        data={this.state.data}
                                        page={this.state.page}
                                        size={this.state.size}
                                        count={this.state.count}
                                        onChangePage={(page, size)=>{
                                            this.onChangePage(page, size)
                                        }}
                    ></PageTableComponent>


                <Apply  ref={(currentId) => this.showApply = currentId}
                        title={'查看申请'}
                        name={this.state.currentName}
                        disabled={true}
                        callBackData={()=>{
                           if(this.state.currentName === '待我审核'){
                                this.getWaitList()
                            }else{
                                this.getList()
                            }
                        }}></Apply>
            </div>
        )
    }

    //分页 数据
    onChangePage(page, page_size) {
        this.setState({page: page, size: page_size},()=>{
            if(this.state.currentName==='待我审核'){
                this.getWaitList()
            } else{
                this.getList()
            }
        })
    }

    download = (record)=>{
       if(record.applyNum === 1){
           confirm({
               content: '确认下载当前文件？',
               okText: '确定',
               cancelText: '取消',
               onOk:()=> {
                   record.virtualFileList.forEach((item)=>{
                       let parms={
                           virtualFileId:item.id,
                           name:item.name,
                           downloadFlag:false
                       };
                       this.request({
                           url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
                           method: "post",
                           body:parms,
                           contentType:'json',
                           callBack: (data) => {
                               if(data){
                                   let url = "/storage/downloadFile?md5="+data.md5+'&download=1'+'&name='+data.name;
                                   let aObj = document.createElement('a');
                                   aObj.setAttribute('download','');
                                   aObj.setAttribute('href',url);
                                   aObj.click();
                                   aObj = null;
                               }
                           }
                       });
                   })
               }})

       }else{
           confirm({
               content: '确认下载当前文件？',
               okText: '确定',
               cancelText: '取消',
               onOk:()=> {
                   this.request({
                       url: "/cm-sites-storage-management/zykDownLoad/batchDownLoad",
                       method: "post",
                       body:{virtualFileIds:record.virtualFileIds.join(',')},
                       contentType: "json",
                       callBack: (data) => {
                           Modal.confirm({
                               title: '已成功添加下载队列',
                               content: '请前往“我的下载”页面查看下载',
                               okText: "确定前往",
                               cancelText: '关闭',
                               icon: <Icon type="check-circle"/>,
                               onOk: () =>{
                                   this.state.history.push("/view/downLoad/downLoad");
                               },
                               onCancel:() =>{
                               }
                           });
                       }
                   });
               },
               onCancel() {
               },
           });
       }

    };

    //表格行背景色
    getRowClassName = (record, index) => {
        let className = '';
        className = index % 2 === 0 ? "evenRow" : "oddRow";
        return className;
    };
    showModalApply=(record)=>{
      this.showApply.show(true,record)
    };
    tableList(){
        this.request({
            url: "/cm-sites-storage-management/applyForResource/getApplyMenus ",
            method: "get",
            contentType: "json",
            callBack: (data) => {
                if(data){
                  this.setState({tabList:data,currentName:data[0]},()=>{
                      this.getList()
                  })
                }
            }
        });
    }
    getList(){
        
        let parms ={
            page:this.state.page,
            size:this.state.size,
            applyMenuName:this.state.currentName
        };
        this.request({
            url: "/cm-sites-storage-management/applyForResource/pageList",
            method: "post",
            body:parms,
            contentType: "json",
            callBack: (data) => {
                if(data){
                  this.setState({data:data.data,count:data.count,selectedRowKeys:[]},()=>{
                      $('.ant-pagination-options-quick-jumper').find('input').val('')
                  })
                }
            }
        });
    }

    getWaitList=()=>{
        let parms ={
            operatorUser: window.top.currentUser.id,
            activitiCategoryKeys: ["zyxzsq"],
            page: {
                size: this.state.size,
                start: this.state.page
            },
            showData: true,
            title: "",
        };
        this.request({
            url: "/cm-sites-sys/process/getTodoList",
            method: "post",
            body:parms,
            contentType: "json",
            callBack: (data) => {
                if(data&&data.data){
                     this.state.count = data.data.count;
                     let newArray = [];
                     if(data&&data.data&&data.data.length&&data.data){
                         data.data.forEach((item,index)=>{
                             newArray.push(item.data)
                         })
                     }
                     this.setState({data:newArray,count:data.count},()=>{
                         $('.ant-pagination-options-quick-jumper').find('input').val('')
                     })
                }
            }
        });
    }







}